/**
 * Error taxonomy for Deckspace operations.
 *
 * @deckspace/errors is the universal foundation. It has no @deckspace/* dependencies.
 * All other packages depend on this one for the runtime error class and the typed
 * error-code/info contract.
 */
/**
 * Custom error class for Deckspace operations.
 * Includes error code for programmatic handling and details for debugging.
 */
export class DeckspaceError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message);
        this.name = 'DeckspaceError';
        this.code = code;
        this.details = details ?? {};
        const ErrorWithCapture = Error;
        if (typeof ErrorWithCapture.captureStackTrace === 'function') {
            ErrorWithCapture.captureStackTrace(this, DeckspaceError);
        }
    }
    /**
     * Convert to serializable error info for API responses
     */
    toInfo() {
        return {
            code: this.code,
            message: this.message,
            details: Object.keys(this.details).length > 0 ? this.details : undefined,
        };
    }
}
//# sourceMappingURL=index.js.map